var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-map"},[_c('div',{ref:"googleMap",staticClass:"google-map"}),_vm._v(" "),(Boolean(_vm.google) && Boolean(_vm.map))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }